import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { Switch } from "antd"
import Footer from "../components/footer"
import { Link } from "react-router-dom"

const EmailAndAlertsPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [newsletter, setNewsLetter] = useState(true)
    const [recommendJobs, setRecommendJobs] = useState(true)
    const [shifts, setShifts] = useState(true)
    const [savedSearches, setSavedSearches] = useState(true)

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }
    return (
        <Navbar active={"emailAndAlerts"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-bold">Prefences</h1>
            </div>
            <div className="relative top-14 min-h-[90vh] bg-gray-100 pb-20">

                <div className="flex flex-col lg:flex-row gap-10 px-4 py-6">
                    <div className="flex flex-col gap-y-3 bg-white p-3 w-full lg:w-1/2 rounded-lg">
                        <div className="w-full lg:w-full border-b">
                            <div className="flex w-full justify-between">
                                <span className="font-semibold">
                                    Newsletter
                                </span>
                                <Switch className="bg-gray-200" onChange={(e) => setNewsLetter(e)} checked={newsletter}></Switch>
                            </div>
                            <p className="py-2 text-[14px]">Receive our newsletter emails to stay up to date.ٖ</p>
                        </div>
                        <div className="w-full lg:w-full border-b">
                            <div className="flex w-full justify-between">
                                <span className="font-semibold">
                                    Recommended jobs
                                </span>
                                <Switch checked={recommendJobs} onChange={(e) => setRecommendJobs(e)} className="bg-gray-200"></Switch>
                            </div>
                            <p className="py-2 text-[14px]">Receive emails when your recruiter recommends jobs for you.
                            </p>
                        </div>
                        <div className="w-full lg:w-full">
                            <div className="flex w-full justify-between">
                                <span className="font-semibold">
                                    Shifts
                                </span>
                                <Switch checked={shifts} onChange={(e) => setShifts(e)} className="bg-gray-200"></Switch>
                            </div>
                            <p className="py-2 text-[14px]">Receive emails when your recruiter recommends jobs for you.
                            </p>
                        </div>
                    </div>


                    <div className="flex flex-col gap-y-3 bg-white p-3 h-fit w-full lg:w-1/2 rounded-lg">
                        <div className="w-full border-b">
                            <div className="flex w-full justify-between">
                                <span className="font-semibold">
                                    Saved searches
                                </span>
                                <Switch checked={savedSearches} onChange={(e) => setSavedSearches(e)} className="bg-gray-200"></Switch>
                            </div>
                            <p className="py-2 text-[14px]">Receive emails when we post new jobs that match your saved searches.</p>
                        </div>
                        <div className="w-full border-b">
                            <div className="flex w-full justify-between">
                                <span className="font-semibold">
                                    You haven't saved any searches yet!
                                </span>
                            </div>
                            <p className="py-2 text-[12px] text italic">Save a search in the <Link className="hover:underline font-semibold ">Search Jobs Page</Link> and set up email alerts for new jobs that match.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fixed bottom-0 w-full">
                <Footer />
            </div>
        </Navbar>
    )
}

export default EmailAndAlertsPage